<template>
  <ag-grid-vue
    style="width: 100%; height: 60vh; min-height: 200px"
    :class="{'ag-theme-balham' : !this.$vuetify.theme.dark,
            'ag-theme-balham-dark' : this.$vuetify.theme.dark }"
    :gridOptions="gridApi.gridOptions"

    :enableColResize="true"
    :enableSorting="true"

    :defaultColDef="gridApi.defaultColDef"
    :columnDefs="gridApi.columnDefs"
    :frameworkComponents="gridApi.frameworkComponents"

    :context="context"
    :rowData="registerList"

    rowSelection="multiple"
    @grid-ready="onGridReady"
    @cellClicked="onClickRow"
    @cell-value-changed="onCellValueChanged"
  />
</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import {agGridDatePicker} from "@/utils/agGrid_util";
import { btnRendererComplete, btnCreateAssign, btnRendererZoomAcceptRequest} from "@/components/Grid/GridRegisterButtonRenderer";
import {cellRendererAssignStatus} from "@/components/Grid/GridCellRenderer";
import apiManager from "@/api/modules/api-manager";
import {mapGetters} from "vuex";
import apiRegister from "@/api/modules/api-register";

export default {
  name: 'GridRegister',
  components: {AgGridVue,
    btnRendererZoomAcceptRequest,
    btnRendererComplete,
    btnCreateAssign,
    cellRendererAssignStatus
  },
  props: {
    registerList: Array
  },
  data() {
    return {
      listLoading: true,
      context: '',
      columnApi: null,

      selectedRow: {},
      selectedTeacher: {},
      searchTeacherDialog: false,

      gridApi: {
        defaultColDef: {
          sortable: true,
          flex: 8,
          wrapText: true,
          filter: true,
          resizable: true
        },
        gridOptions: {
          animateRows: false,
          frameworkComponents: {},
        },
        columnDefs: [
          {flex: 0.4, colId:'id', valueGetter: "node.rowIndex + 1"},
          {flex: 0.7, colId: 'registerId', headerName: 'Id', field: 'registerId', },
          {flex: 1.2, colId: 'startDate', headerName: 'Start Date', field: 'startDate', editable: true, cellEditor: agGridDatePicker, },
          {flex: 0.9, colId: 'classStartTime', headerName: 'Start Time', field: 'classStartTime', },
          {flex: 0.8, colId: 'courseName' , headerName: 'Course', field: 'courseName', cellStyle: { color: 'orange' }, },
          {flex: 0.8, field: 'contentName', headerName: 'Content', },
          {flex: 0.8, colId: 'callAppType' , headerName: 'Call App Type', field: 'callAppType', },
          {flex: 1.5, colId: 'skypeId', headerName: 'Teams/Zoom', field: 'skypeId', editable: true, },
          {flex: 1,   colId: 'studentName', headerName: 'Student Kor', field: 'studentName', editable: true, },
          {flex: 1,   colId: 'studentEngName' , headerName: 'Student', field: 'studentEngName', editable: true, },
          {flex: 1,   colId: 'teacherName', headerName: 'Teacher', field: 'teacherName', },
          {flex: 1,   colId: 'registerStatus', headerName: 'Status', field: 'registerStatus', },
          {flex: 1.3, colId: 'zoomRequest',      headerName: 'Zoom Request', field: 'zoomRequest',      cellRendererFramework: "btnRendererZoomAcceptRequest"},
          {flex: 1,   colId: 'feedback',      headerName: 'Feedback(press Enter)', field: 'feedback',  editable: true, cellEditor: 'agLargeTextCellEditor', cellEditorPopup: true, cellStyle: {'background-color': 'grey'} },
          {flex: 1.3, colId: "testComplete",      headerName: 'Test Complete', field: 'testComplete',    cellRendererFramework: "btnRendererComplete"},
        ]
      },
    }
  },
  computed: {
    ...mapGetters(['app', 'user','isMobile','isOwner', 'isManager'])
  },
  created() { },
  mounted() {
    window.addEventListener('resize', this.hideActionColumn);
  },
  methods: {
    updateData(row) {
      return apiManager.putRegister(row)
          .then(res => {
            const index = this.registerList.findIndex(v => v.registerId === row.registerId)
            this.registerList.splice(index, 1, res)
          })
          .then(() => this.$dialog.notify.info('Success', {position: 'top-right', timeout: 1000}))
          .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
    },


    onGridReady(params){
      params.api.setHeaderHeight(60);
      this.columnApi = params.columnApi;
      this.hideActionColumn()
    },
    onClickRow(params){
      let row = params.data
      switch (params.column.getId()){
        case "studentName":
        case "studentEngName":
          this.$emit('showSelectStudentDialog', row)
          break;
        case "teacherName":          //          event.rowIndex  / event.colDef.headerName
          this.$emit('showSelectTeacherDialog', row)
          break;
        case "zoomRequest":          //          event.rowIndex  / event.colDef.headerName
          // if (row.registerStatus != 'NO_TEST') return
          apiRegister.requestZoomAccept(row)
                .then(() => this.$dialog.notify.info('Success', {position: 'top-right', timeout: 1000}))
                .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right', timeout: 1500}))
          break;
        case "feedback":          //          event.rowIndex  / event.colDef.headerName
          this.$emit('showFeedbackDialog', row)
          break;
        case "testComplete":
          if (!this.isManager) return
          apiManager.putRegisterCompleteTest(row)
              .then(res =>{
                row.registerStatus = "ACTIVE"
                const index = this.registerList.findIndex(v => v.registerId === row.registerId)
                this.registerList.splice(index, 1, res)
                return res
              })
              .then(() => this.$dialog.notify.info('Success', {position: 'top-right',timeout: 1000}))
              .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
          break;
        case "createAssign":
          apiManager.createAssign(row)
              .then(() => this.$dialog.notify.info('Success', {position: 'top-right',timeout: 1000}))
              .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
          break;
        case "skypeId": break;
        default:
          this.$emit('showRegisterDialog', row)
          break;
      }
    },
    onCellValueChanged(params) {
      let row = params.data
      let colId = params.column.getId();
      switch (colId) {
        case "studentEngName":
          row.student.englishName = row.studentEngName
          apiManager.setAccount(row.student)
              .then(res => row.student = res)
              .then(() => this.$dialog.notify.info('Success', {position: 'top-right', timeout: 1000}))
              .catch(err => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
          break;
      }
    },
    hideActionColumn() {

      if(this.columnApi) {
        this.columnApi.setColumnVisible( 'id',!this.isMobile)
         this.columnApi.setColumnVisible('startDate', !this.isMobile)
         this.columnApi.setColumnVisible('classStartTime', !this.isMobile)
         this.columnApi.setColumnVisible('courseName', !this.isMobile)
         this.columnApi.setColumnVisible('contentName', !this.isMobile)
         this.columnApi.setColumnVisible('callAppType', !this.isMobile)
         this.columnApi.setColumnVisible('skypeId', !this.isMobile)
         this.columnApi.setColumnVisible('registerStatus', !this.isMobile)
         this.columnApi.setColumnVisible("testComplete", !this.isMobile)
         this.columnApi.setColumnVisible( 'callType',!this.isMobile)
         this.columnApi.setColumnVisible( 'attendFlag',!this.isMobile)
         this.columnApi.setColumnVisible( 'feedback',!this.isMobile)

        this.columnApi.setColumnVisible('testComplete', this.isManager && !this.isMobile)
      }
    },
  }
}
</script>
